import * as Actions from '../actions';

const initialState = {
    questionList:    [],
    currentQuestion: {},
    questionTypes:   [],
}

const questionReducer = function (state = initialState, action) {
    switch(action.type)
    {
        case(Actions.GET_QUESTION):
        {
            return {
                ...state,
                currentQuestion: {...action.payload, question_loaded: true}
            };
        }

        case(Actions.UPDATE_QUESTION):
        {
            return {
                ...state,
                currentQuestion: {...action.payload, question_loaded: true},
                questionList: state.questionList.map((question) => { // Updates Corresponding question in questionList
                    if(question.question_id === action.payload.question_id) {
                        return {...question, ...action.payload};
                    }
                    return question;
                })
            };
        }

        case(Actions.DELETE_QUESTION):
        {
            return {
                ...state,
                currentQuestion: { question_loaded: false },
                questionList: state.questionList.filter((question) => question.question_id !== action.payload) // Removes Corresponding question in questionList
            };
        }

        case(Actions.CREATE_QUESTION):
        {
            return {
                ...state,
                questionList: state.questionList.concat(action.payload)
            }
        }

        case(Actions.GET_QUESTION_LIST):
        {
            return {
                ...state,
                questionList: action.payload
            };
        }

        case (Actions.GET_QUESTION_TYPES):
        {
            return {
                ...state,
                questionTypes: action.payload
            }
        }

        default:
        {
            return state;
        }
    }
}

export default questionReducer;


// WEBPACK FOOTER //
// src/main/content/question/store/reducers/question.reducer.js